import { Link } from "react-router-dom";
import { Wordmark } from "@/components/Wordmark";
import { useLang } from "@/i18n/translations";
import { COMPANY, PROJECTS } from "@/lib/siteConfig";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="relative z-10 border-t border-white/10 bg-[#05070d]">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Wordmark className="text-xl" testId="footer-wordmark" />
            <p className="mt-3 text-sm text-muted-foreground max-w-sm leading-relaxed">{t.footer.tagline}</p>
            <p className="mt-4 text-xs font-mono-cs text-muted-foreground/70">{COMPANY.locations}</p>
          </div>
          <div className="md:col-span-4">
            <p className="text-xs font-mono-cs uppercase tracking-widest text-muted-foreground mb-4">{t.footer.projects}</p>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2">
              {PROJECTS.map((p) => (
                <li key={p.id}>
                  <a
                    data-testid={`footer-project-link-${p.id}`}
                    href={p.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-foreground/70 hover:text-[#00d4ff] transition-colors duration-200"
                  >
                    {p.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs font-mono-cs uppercase tracking-widest text-muted-foreground mb-4">{t.footer.legal}</p>
            <ul className="space-y-2">
              <li>
                <Link data-testid="footer-imprint-link" to="/impressum" className="text-sm text-foreground/70 hover:text-foreground transition-colors duration-200">
                  {t.footer.imprint}
                </Link>
              </li>
              <li>
                <Link data-testid="footer-privacy-link" to="/datenschutz" className="text-sm text-foreground/70 hover:text-foreground transition-colors duration-200">
                  {t.footer.privacy}
                </Link>
              </li>
              <li>
                <a data-testid="footer-contact-link" href={`mailto:${COMPANY.email}`} className="text-sm text-foreground/70 hover:text-foreground transition-colors duration-200">
                  {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} {COMPANY.name} · {t.footer.rights}
          </p>
          <p className="text-xs font-mono-cs text-muted-foreground/80">{COMPANY.domain}</p>
        </div>
      </div>
    </footer>
  );
};
